<template>
  <b-card>
    <div class="row">
      <div class="col-6 d-flex align-items-center justify-content-lg-start">
        <Button
          v-if="(showBackButton && actionType === 'save') || 'add'"
          :label="$t('List page')"
          size="md"
          icon="ArrowLeftIcon"
          show-icon
          class="mb-1"
          @click="backNavigationAction"
        />
      </div>
      <div class="col-6 d-flex justify-content-end">
        <Button
          v-if="showSearchButton"
          :label="$t('Search')"
          size="md"
          icon="SearchIcon"
          show-icon
          @click="showSearchField"
        />
      </div>
    </div>
    <b-row class="position-relative">
      <b-col
        v-if="!showSearchButton"
        md="4"
      >
        <b-row>
          <Alert
            :show="showFormErrorAlert"
            :message="$t('Customer\'s account name, account number, or customer ID is required')"
          />
          <b-col md="12">
            <InputField
              id="customer-id"
              v-model="searchParams.customerID"
              :label="$t('Customer ID')"
              :placeholder="$t('Enter customer Id')"
              type="text"
            />
          </b-col>
          <b-col md="12">
            <InputField
              id="account-number"
              v-model="searchParams.accountNumber"
              :label="$t('Account Number')"
              :placeholder="$t('Enter account number')"
              type="number"
            />
          </b-col>
          <b-col md="12">
            <InputField
              id="account-name"
              v-model="searchParams.accountName"
              :label="$t('Account Name')"
              :placeholder="$t('Enter account name')"
              type="text"
            />
          </b-col>
          <b-col md="12">
            <Button
              :label="$t('Search')"
              size="md"
              class="mt-2"
              block
              @click="handleSearch"
            />
          </b-col>
        </b-row>
      </b-col>
      <b-col
        v-if="showSearchButton"
        :md="showSearchButton === true ? '12' : '8'"
      >
        <div v-if="showCustomerInfo">
          <validation-observer ref="savingsPocketRules">
            <app-collapse
              class="business-items mb-4"
              type="margin"
              accordion
            >
              <app-collapse-item
                :title="$t('Account Summary')"
                class="card-item"
                is-visible
              >
                <b-row>
                  <b-col md="4">
                    <InputField
                      id="account-name"
                      v-model="customer.accountName"
                      :label="$t('Account Name')"
                      type="text"
                      readonly
                    />
                  </b-col>
                  <b-col md="4">
                    <InputField
                      id="account-number"
                      v-model="customer.accountNumber"
                      :label="$t('Account Number')"
                      type="text"
                      readonly
                    />
                  </b-col>
                  <b-col md="4">
                    <InputField
                      id="product-name"
                      v-model="customer.productName"
                      :label="$t('Product Name')"
                      type="text"
                      readonly
                    />
                  </b-col>
                  <b-col md="4">
                    <InputField
                      id="NUBAN"
                      v-model="customer.accountNumber"
                      label="NUBAN"
                      type="text"
                      readonly
                    />
                  </b-col>
                  <b-col md="4">
                    <InputField
                      id="branch"
                      v-model="customer.branchName"
                      :label="$t('Branch')"
                      type="text"
                      readonly
                    />
                  </b-col>
                  <b-col md="4">
                    <InputField
                      id="account-status"
                      v-model="customer.accountStatus"
                      :label="$t('Account Status')"
                      type="text"
                      readonly
                    />
                  </b-col>
                  <b-col md="4">
                    <InputField
                      id="ledger-balance"
                      v-model="customer.ledgerBalance"
                      :label="$t('Ledger Balance')"
                      type="text"
                      readonly
                    />
                  </b-col>
                  <b-col md="4">
                    <InputField
                      id="available-balance"
                      v-model="customer.availableBalance"
                      :label="$t('Available Balance')"
                      type="text"
                      readonly
                    />
                  </b-col>
                  <b-col md="4">
                    <InputField
                      id="withdrawable-balance"
                      v-model="customer.withdrawableBalance"
                      :label="$t('Withdrawable Balance')"
                      type="text"
                      readonly
                    />
                  </b-col>
                  <b-col md="4">
                    <InputField
                      id="overdraft-limit"
                      v-model="customer.overdraftLimit"
                      :label="$t('Overdraft Limit')"
                      type="text"
                      readonly
                    />
                  </b-col>
                  <b-col md="4">
                    <InputField
                      id="account-officer"
                      v-model="customer.accountOfficerName"
                      :label="$t('Account Officer')"
                      type="text"
                      readonly
                    />
                  </b-col>
                </b-row>
              </app-collapse-item>
            </app-collapse>
            <!-- <h5 class="text-capitalize mb-3">
              {{ $t('ADD MEMO') }}
            </h5> -->
            <b-row>
              <b-col md="4">
                <SelectField
                  id="reasons"
                  v-model="savingsPocketFormData.liquidationAccount"
                  :label="$t('Fund Source/Liquidation Account')"
                  rules="required"
                  :error-name="$t('Fund Source/Liquidation Account')"
                  :reduce="option => option.value"
                  :options="searchedAccountOptions"
                  item="label"
                  :placeholder="$t('Select Fund Source/Liquidation Account')"
                />
              </b-col>
              <b-col md="4">
                <SelectField
                  id="savings-pocket-type"
                  v-model="savingsPocketFormData.savingsType"
                  :label="$t('Savings Pocket Type')"
                  rules="required"
                  :error-name="$t('Savings Pocket Type')"
                  :reduce="option => option.value"
                  :options="savingsTypesOptions"
                  item="label"
                  :placeholder="$t('Select Savings Pocket Type')"
                  :set-selected="getRateAndBankDaysInYear(savingsPocketFormData.savingsType)"
                />
              </b-col>
              <b-col md="4">
                <SelectField
                  id="product"
                  v-model="savingsPocketFormData.productCode"
                  :label="$t('Product')"
                  :options="getProductOptions(savingsPocketFormData.savingsType)"
                  :error-name="$t('Product')"
                  rules="required"
                  :reduce="option => option.value"
                  item="label"
                  :placeholder="$t('Select')"
                  :readonly="isReadonly"
                />
              </b-col>
            </b-row>
            <b-row v-if="savingsPocketFormData.savingsType === 'FrequentSave'">
              <b-col md="4">
                <InputField
                  id="frequent-saving-name"
                  v-model="savingsPocketFormData.pocketName"
                  :label="$t('Frequent Saving Name')"
                  type="text"
                  :error-name="$t('Frequent Saving Name')"
                  rules="required"
                  :readonly="isReadonly"
                />
              </b-col>
              <b-col md="4">
                <InputNumberField
                  id="frequent-amount-maturity"
                  v-model="savingsPocketFormData.amount"
                  :label="$t('Frequent Amount at Maturity')"
                  type="number"
                  :error-name="$t('Frequent Amount at Maturity')"
                  rules="required|positive"
                  :readonly="isReadonly"
                />
              </b-col>
              <b-col md="4">
                <SelectField
                  id="frequent-saving-frequency"
                  v-model="savingsPocketFormData.frequency"
                  :label="$t('Frequent Saving Frequency')"
                  :options="frequencyOptions"
                  :error-name="$t('Frequent Saving Frequency')"
                  rules="required"
                  :reduce="option => option.value"
                  item="label"
                  :placeholder="$t('Select')"
                  :readonly="isReadonly"
                />
              </b-col>
              <b-col md="4">
                <InputField
                  id="interest-rate"
                  v-model="savingsRate"
                  :label="$t('Interest Rate')"
                  type="text"
                  readonly
                />
              </b-col>
            </b-row>
            <b-row
              v-if="savingsPocketFormData.savingsType === 'FrequentSave' &&
                ['Daily', 'Weekly', 'Monthly'].includes(
                  savingsPocketFormData.frequency
                )"
            >
              <b-col
                v-if="savingsPocketFormData.frequency === 'Daily'"
                md="4"
              >
                <InputField
                  id="duration"
                  v-model="savingsPocketFormData.duration"
                  :label="$t('Duration (in days)')"
                  type="number"
                  :error-name="$t('Duration (in days)')"
                  rules="required|positive|min:1"
                  :readonly="isReadonly"
                  @input="setEstimatedSavingsAmount(savingsPocketFormData.duration, 'Daily')"
                />
              </b-col>
              <b-col
                v-if="savingsPocketFormData.frequency === 'Weekly'"
                md="4"
              >
                <SelectField
                  id="duration-weekly"
                  v-model="savingsPocketFormData.duration"
                  :label="$t('Duration (in weeks)')"
                  :options="weeklyOptions"
                  :error-name="$t('Duration (in weeks)')"
                  rules="required"
                  :reduce="option => option.value"
                  item="label"
                  :placeholder="$t('Select')"
                  :readonly="isReadonly"
                  :set-selected="setEstimatedSavingsAmount(savingsPocketFormData.duration, 'Weekly')"
                />
              </b-col>
              <b-col
                v-if="savingsPocketFormData.frequency === 'Monthly'"
                md="4"
              >
                <SelectField
                  id="duration-monthly"
                  v-model="savingsPocketFormData.duration"
                  :label="$t('Duration (in months)')"
                  :options="monthlyOptions"
                  :error-name="$t('Duration (in months)')"
                  rules="required"
                  :reduce="option => option.value"
                  item="label"
                  :placeholder="$t('Select')"
                  :readonly="isReadonly"
                  :set-selected="setEstimatedSavingsAmount(savingsPocketFormData.duration, 'Monthly')"
                />
              </b-col>
              <b-col md="4">
                <DatePickerField
                  id="start-date"
                  v-model="savingsPocketFormData.startDate"
                  rules="required"
                  :min-date="new Date()"
                  :label="$t('Start Date')"
                  :error-name="$t('Start Date')"
                  :on-change="setEndDate"
                  :config="currentFinDatePickerConfig"
                  :placeholder="$t('Select Start Date')"
                  :disabled="isReadonly"
                />
              </b-col>
              <b-col md="4">
                <InputField
                  id="end-date"
                  v-model="savingsPocketFormData.endDate"
                  :label="$t('End Date')"
                  type="text"
                  :error-name="$t('End Date')"
                  rules="required"
                  readonly
                />
              </b-col>
              <b-col md="4">
                <InputNumberField
                  id="estimated-savings-amount"
                  v-model="savingsPocketFormData.estimatedSavingsAmount"
                  :label="$t('Estimated Savings Amount')"
                  type="number"
                  :error-name="$t('Estimated Savings Amount')"
                  rules="required"
                  readonly
                />
              </b-col>
            </b-row>
            <b-row v-if="savingsPocketFormData.savingsType === 'FlexSave'">
              <b-col md="4">
                <InputField
                  id="flex-saving-name"
                  v-model="savingsPocketFormData.pocketName"
                  :label="$t('Flex Saving Name')"
                  type="text"
                  :error-name="$t('Flex Saving Name')"
                  rules="required"
                  :readonly="isReadonly"
                />
              </b-col>
              <b-col md="4">
                <InputNumberField
                  id="flex-savings-amount"
                  v-model="savingsPocketFormData.amount"
                  :label="$t('Amount to Save')"
                  type="number"
                  :error-name="$t('Amount to Save')"
                  rules="required"
                  :readonly="isReadonly"
                />
              </b-col>
              <b-col md="4">
                <DatePickerField
                  id="flex-start-date"
                  v-model="savingsPocketFormData.startDate"
                  rules="required"
                  :min-date="new Date()"
                  :label="$t('Start Date')"
                  :error-name="$t('Start Date')"
                  :config="currentFinDatePickerConfig"
                  :placeholder="$t('Select Start Date')"
                  :disabled="isReadonly"
                />
              </b-col>
            </b-row>
            <b-row v-if="savingsPocketFormData.savingsType === 'SmartSave'">
              <b-col md="4">
                <InputField
                  id="flex-saving-name"
                  v-model="savingsPocketFormData.pocketName"
                  :label="$t('Flex Saving Name')"
                  type="text"
                  :error-name="$t('Flex Saving Name')"
                  rules="required"
                  :readonly="isReadonly"
                />
              </b-col>
              <b-col md="4">
                <InputNumberField
                  id="flex-savings-amount"
                  v-model="savingsPocketFormData.percentage"
                  :label="$t('Percentage of spent amount to be saved')"
                  type="number"
                  :error-name="$t('Percentage of spent amount to be saved')"
                  rules="required|positive|min-value|max-value:100"
                  :readonly="isReadonly"
                />
              </b-col>
              <b-col md="4">
                <DatePickerField
                  id="auto-start-date"
                  v-model="savingsPocketFormData.startDate"
                  rules="required"
                  :min-date="new Date()"
                  :label="$t('Start Date')"
                  :error-name="$t('Start Date')"
                  :config="currentFinDatePickerConfig"
                  :placeholder="$t('Select Start Date')"
                  :disabled="isReadonly"
                />
              </b-col>
            </b-row>
          </validation-observer>
          <div class="button-center mt-5">
            <div>
              <Button
                :label="$t('Submit')"
                :loading="isLoading"
                size="lg"
                @click="handleSubmit"
              />
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-modal
      id="search-modal"
      ref="search-modal-lg"
      :cancel-title="$t('Cancel')"
      cancel-variant="outline-secondary"
      centered
      size="lg"
      :title="$t('Customer Details')"
      cancel-title-only
      @hidden="resetModal"
    >
      <b-table
        ref="customerListTable"
        select-mode="single"
        :items="customerList"
        responsive
        :fields="translatedTableHeaders"
        primary-key="id"
        selectable
        show-empty
        :empty-text="$t('No result found')"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        class="position-relative"
        @row-selected="onSelectCustomer"
      >
        <template #cell(SN)="data">
          {{ getOverallIndex(data.index) }}
        </template>
      </b-table>
      <TablePagination
        v-model="currentPage"
        :from="from"
        :to="to"
        :total-rows="totalEntries"
        :per-page="perPage"
      />
      <template #modal-footer="{}">
        <div />
      </template>
    </b-modal>
    <FullScreenSpinner :show="showSpinner" />
  </b-card>
</template>

<script>
import {
  BCard, BRow, BCol, BTable,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { heightFade } from '@core/directives/animations'
import { required, positive } from '@validations'
import { ValidationObserver } from 'vee-validate'
import { sweetAlert } from '@core/mixins/sweetAlert'
import { tableMixins } from '@core/mixins/table'
import { mapActions, mapGetters } from 'vuex'
import { modalMixins } from '@core/mixins/modal'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import { accountPermissions } from '@/helpers/permissions'
import TablePagination from '@/views/components/table/TablePagination.vue'
import FullScreenSpinner from '@/views/components/spinner/FullScreenSpinner.vue'
import { toBalance, toKobo } from '@/helpers/formatAmount'
import { toDateWithMonth, toDateWithYear, toYearWithDate } from '../../../../../helpers/formatDate'
import InputField from '../../../../forms/InputField.vue'
import InputNumberField from '../../../../forms/InputNumberField.vue'
import SelectField from '../../../../forms/SelectField.vue'
import Button from '../../../../components/button/Button.vue'
import DatePickerField from '../../../../forms/DatePickerField.vue'
import Alert from '../../../../components/alert/Alert.vue'

export default {
  components: {
    BRow,
    BCol,
    InputField,
    InputNumberField,
    SelectField,
    Button,
    TablePagination,
    Alert,
    BTable,
    BCard,
    FullScreenSpinner,
    ValidationObserver,
    AppCollapse,
    AppCollapseItem,
    DatePickerField,
  },
  directives: {
    Ripple,
    'height-fade': heightFade,
  },
  mixins: [sweetAlert, tableMixins, modalMixins],
  data() {
    return {
      toDateWithYear,
      toYearWithDate,
      toDateWithMonth,
      actionType: 'save',
      isDisabled: false,
      isLoading: false,
      showFormErrorAlert: false,
      showCustomerInfo: false,
      showSearchButton: false,
      showBackButton: false,
      isEditable: true,
      required,
      positive,
      showSpinner: false,
      sortDesc: false,
      currentPage: 1,
      perPage: 10,
      sortBy: 'accountName',
      searchParams: {
        accountNumber: null,
        accountName: null,
        customerID: null,
      },
      savingsRate: '',
      bankDaysInYear: '',
      savingsPocketFormData: {
        liquidationAccount: '',
        savingsType: '',
        productCode: '',
        pocketName: '',
        frequency: '',
        duration: '',
        startDate: '',
        endDate: '',
        percentage: '',
        estimatedSavingsAmount: '',
      },
      frequencyOptions: [
        {
          value: 'Daily',
          label: this.$t('Daily'),
        },
        {
          value: 'Weekly',
          label: this.$t('Weekly'),
        },
        {
          value: 'Monthly',
          label: this.$t('Monthly'),
        },
      ],
      fdProductOptions: [],
      casaProductOptions: [],
      customerList: [],
      searchedAccountOptions: [],
      savingsTypesOptions: [
        {
          value: 'FrequentSave',
          label: this.$t('Frequent Savings'),
        },
        {
          value: 'FlexSave',
          label: this.$t('Flex Savings'),
        },
        {
          value: 'SmartSave',
          label: this.$t('AutoSave Savings'),
        },
      ],

      currentFinDatePickerConfig: {
        dateFormat: 'Y-m-d',
        minDate: '',
        defaultDate: '',
      },
      customer: {
        accountName: '',
        accountNumber: '',
        productName: '',
        branchName: '',
        accountStatus: '',
        ledgerBalance: '',
        availableBalance: '',
        withdrawableBalance: '',
        overdraftLimit: '',
        accountOfficerName: '',
        originalLedgerBalance: 0,
      },
      tableHeaders: [
        { key: 'SN', label: 'S/N' },
        { key: 'customerID', sortable: true, label: this.$t('Customer ID') },
        { key: 'accountName', sortable: true, label: this.$t('Account Name') },
        { key: 'accountNumber', sortable: true, label: this.$t('Account Number') },
      ],
    }
  },
  computed: {
    totalEntries() {
      return this.customerList.length
    },
    numberOfPages() {
      return Math.floor((this.totalEntries + this.perPage - 1) / this.perPage)
    },
    from() {
      return this.currentPage * this.perPage - (this.perPage - 1)
    },
    to() {
      return Math.min(this.from + this.perPage - 1, this.totalEntries)
    },
    ...mapGetters({
      currentFinancialDate: 'operations/getCurrentFinancialDate',
      userDetails: 'auth/getCurrentUser',
    }),
    getPreviousFinancialDates() {
      return this.currentFinancialDate.financialDate
    },
    weeklyOptions() {
      const totalWeeks = 52
      return Array.from({ length: totalWeeks }, (_, i) => ({
        value: String(i + 1),
        label: `Week ${i + 1}`,
      }))
    },
    // preferredMonthOptions() {
    //   return Array.from({ length: 31 }, (_, i) => ({
    //     value: String(i + 1),
    //     label: this.$t(String(i + 1)),
    //   }))
    // },
    monthlyOptions() {
      return Array.from({ length: 12 }, (_, i) => ({
        value: String(i + 1),
        label: this.$t(String(i + 1)),
      }))
    },
    // totalDays() {
    //   if (!this.savingsPocketFormData.duration) return 0
    //   const year = new Date().getFullYear()
    //   return new Date(year, this.savingsPocketFormData.duration, 0).getDate()
    // },
    translatedTableHeaders() {
      return this.tableHeaders.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.key }))
    },
  },
  mounted() {
    this.fetchCASAProducts()
    this.fetchFDProducts()
    this.currentFinDatePickerConfig.minDate = this.getPreviousFinancialDates
  },
  methods: {
    ...mapActions({
      searchCustomerAccount: 'account/searchCustomerAccountAction',
      createSavingsPocket: 'account/createSavingsPocketAction',
      getUserBalance: 'account/getCASABalanceAction',
      getProducts: 'account/getProducts',
      getSavingsRate: 'eChannels/getSavingsRateDetails',
    }),
    isFrequentSave(savingsType) {
      return savingsType === 'FrequentSave'
    },
    getProductOptions(savingsType) {
      return this.isFrequentSave(savingsType)
        ? this.fdProductOptions
        : this.casaProductOptions
    },
    setEndDate(dateStr) {
      const selectedDate = Array.isArray(dateStr) ? dateStr[0] : dateStr
      const startDate = new Date(selectedDate)
      const durations = Number(this.savingsPocketFormData.duration) || 0
      const { frequency } = this.savingsPocketFormData
      if (!durations) {
        this.savingsPocketFormData.endDate = ''
        return
      }
      let totalDays = 0
      switch (frequency) {
        case 'Weekly':
          totalDays = durations * 7 // Convert weeks to days
          break
        case 'Monthly':
          totalDays = durations * 30 // Convert months to days
          break
        case 'Daily':
        default:
          totalDays = durations // Already in days
          break
      }
      // Add total days to start date
      startDate.setDate(startDate.getDate() + Number(totalDays))
      // eslint-disable-next-line prefer-destructuring
      this.savingsPocketFormData.endDate = startDate.toISOString().split('T')[0]
    },
    setEstimatedSavingsAmount(durations, durationType) {
      let totalDuration = 0
      if (durationType === 'Weekly') {
        totalDuration = Number(durations) * 7
      } else if (durationType === 'Monthly') {
        totalDuration = Number(durations) * 30
      } else {
        totalDuration = Number(durations)
      }
      const dailyAmount = (Number(this.savingsPocketFormData.amount) / totalDuration)
      const interestRate = Number(this.savingsRate) / 100
      this.savingsPocketFormData.estimatedSavingsAmount = (dailyAmount * (interestRate / Number(this.bankDaysInYear))) * ((Number(totalDuration) * (Number(totalDuration) + 1)) / 2)
    },
    async getRateAndBankDaysInYear(savingsType) {
      if (savingsType === 'FrequentSave') {
        try {
          const response = await this.getSavingsRate({ permission: accountPermissions.VIEW_SAVINGS_POCKET })
          const { status, data } = response
          if (status === 200 && data?.data) {
            this.savingsRate = data?.data?.[0]?.config?.[0]?.applicableInterestRate || 0
            this.bankDaysInYear = data?.daysInYear || 0
          }
        } catch (error) {
          this.alertError({ text: error })
        }
      }
    },
    async handleSearch() {
      try {
        const isSearchParamsNotEmpty = Object.values(this.searchParams).every(
          params => params === null || params === '',
        )
        if (!isSearchParamsNotEmpty) {
          this.showFormErrorAlert = false
          this.showSpinner = true
          const response = await this.searchCustomerAccount({
            search: this.searchParams,
            page: this.currentPage,
            limit: this.perPage,
            permission: accountPermissions.VIEW_SAVINGS_POCKET,
          })
          const { status, data } = response
          if (status === 200 && data?.data) {
            this.customerList = data.data
            this.searchedAccountOptions = data.data.map(item => ({
              label: `${item.accountName} - ${item.accountNumber}`,
              value: item.accountNumber,
            }))
            this.totalCount = data.recordCount
            this.showSpinner = false
            this.$root.$emit('bv::show::modal', 'search-modal')
          } else {
            this.customerList = []
            this.totalCount = data.recordCount
            this.$root.$emit('bv::show::modal', 'search-modal')
          }
        } else {
          this.showFormErrorAlert = true
          this.showSpinner = false
        }
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.showSpinner = false
      }
    },
    async onSelectCustomer(items) {
      try {
        const [customer] = items
        this.hideModal('search-modal')
        this.showSpinner = true
        this.showBackButton = true
        const response = await this.getUserBalance({ accountNumber: customer.accountNumber, permission: accountPermissions.VIEW_SAVINGS_POCKET })
        const { data, status } = response
        if (status === 200) {
          this.customer = {
            ...customer,
            availableBalance: data.availableBalance ? toBalance(data.availableBalance) : 0,
            withdrawableBalance: data.withdrawableBalance ? toBalance(data.withdrawableBalance) : 0,
            ledgerBalance: data.ledgerBalance ? toBalance(data.ledgerBalance) : 0,
            overdraftLimit: data.overdraftLimit ? toBalance(data.overdraftLimit) : 0,
            originalLedgerBalance: data.ledgerBalance,
          }
          this.savingsPocketFormData.pocketName = customer.accountName
          if (data.accountStatus === 'Closed') {
            const closedText = this.$t('has been closed')
            this.alertError({ text: `${data.accountName} - ${data.accountNumber} ${closedText}.` })
            this.isDisabled = true
          }
        }
        this.showCustomerInfo = true
        this.showSearchButton = true
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.showSpinner = false
      }
    },
    async fetchCASAProducts() {
      try {
        const response = await this.getProducts({
          search: { type: 'Savings' },
          page: 0,
          limit: 0,
          permission: accountPermissions.VIEW_SAVINGS_POCKET,
        })
        const { status, data } = response
        if (status === 200 && data.data) {
          this.casaProductOptions = data.data.filter(itemValue => itemValue.status === 'Active').map(item => ({ label: item.name, value: item.code.toString() }))
        }
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.isBusy = false
      }
    },
    async fetchFDProducts() {
      try {
        const response = await this.getProducts({
          search: { type: 'FixedDeposit' },
          page: 0,
          limit: 0,
          permission: accountPermissions.VIEW_SAVINGS_POCKET,
        })
        const { status, data } = response
        if (status === 200 && data.data) {
          this.fdProductOptions = data.data.filter(itemValue => itemValue.status === 'Active').map(item => ({ label: item.name, value: item.code.toString() }))
        }
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.isBusy = false
      }
    },
    async handleSubmit() {
      this.$refs.savingsPocketRules.validate().then(success => {
        if (success) {
          const textQuestion = this.$t('Are you sure you want to create savings pocket on this account?')
          this.confirm(this.createSavingsPocketAccount, { text: `${textQuestion}: ${this.customer.accountNumber} ?` })
        }
      })
    },
    async createSavingsPocketAccount() {
      try {
        this.isLoading = true
        this.isDisabled = true
        let savingsModelItems = {}
        if (this.savingsPocketFormData.savingsType === 'FrequentSave') {
          savingsModelItems = {
            pocketName: this.savingsPocketFormData.pocketName,
            liquidationAccount: this.savingsPocketFormData.liquidationAccount,
            productCode: this.savingsPocketFormData.productCode,
            amount: toKobo(this.savingsPocketFormData.amount),
            deductionAmount: toKobo(this.savingsPocketFormData.estimatedSavingsAmount),
            frequency: this.savingsPocketFormData.frequency,
            commencementDate: this.savingsPocketFormData.startDate,
            maturityDate: this.savingsPocketFormData.endDate,
            duration: this.savingsPocketFormData.duration,
            interestRate: this.savingsRate,
          }
        } else if (this.savingsPocketFormData.savingsType === 'FlexSave') {
          savingsModelItems = {
            pocketName: this.savingsPocketFormData.pocketName,
            liquidationAccount: this.savingsPocketFormData.liquidationAccount,
            productCode: this.savingsPocketFormData.productCode,
            amount: toKobo(this.savingsPocketFormData.amount),
            commencementDate: this.savingsPocketFormData.startDate,
          }
        } else {
          savingsModelItems = {
            pocketName: this.savingsPocketFormData.pocketName,
            liquidationAccount: this.savingsPocketFormData.liquidationAccount,
            productCode: this.savingsPocketFormData.productCode,
            percentage: this.savingsPocketFormData.percentage,
            commencementDate: this.savingsPocketFormData.startDate,
          }
        }
        const formData = {
          savingsType: this.savingsPocketFormData.savingsType,
          savingsModel: savingsModelItems,
        }
        const response = await this.createSavingsPocket({ formData, permission: accountPermissions.CREATE_SAVINGS_POCKET })
        const { status, data } = response
        if (status === 200 && data) {
          this.showCustomerInfo = false
          this.isLoading = false
          this.isDisabled = false
          this.resetInputField()
          this.resetSearchParams()
          this.alertSuccess({ text: this.$t('Your Savings Pocket request was successful') })
          this.$router.push('savings-pockets')
        }
      } catch (error) {
        this.handleError(error)
      } finally {
        this.isLoading = false
        this.isDisabled = false
      }
    },
    resetInputField() {
      this.searchParams = { ...null }
      this.savingsPocketFormData = { ...null }
      this.customer = { ...null }
      this.isLoading = false
      this.isDisabled = false
      this.showCustomerInfo = false
      this.showSearchButton = false
      this.showBackButton = false
    },
    showSearchField() {
      this.showSearchButton = false
      this.resetSearchParams()
    },
    resetSearchParams() {
      this.searchParams.accountNumber = null
      this.searchParams.accountName = null
      this.searchParams.customerID = null
    },
    resetModal() {
      this.customerList = []
    },
    backNavigationAction() {
      this.showBackButton = true
      this.$router.push({
        name: 'savings-pockets',
      })
    },
  },
}
</script>
<style scoped>
[dir] .demo-inline-spacing > *,
.custom-control,
.custom-control-inline,
.custom-checkbox {
  margin-top: 0rem !important;
}
.card-item {
  border: 1px solid #d8d6de !important;
  border-radius: 0.358rem;
}
.button-center {
  display: flex;
  justify-content: center;
}
</style>
